// extracted by mini-css-extract-plugin
export default {"setDeliveryDateButton-desktop":"Gbdc6c3","setDeliveryDateButton-mobile":"Gcb74cb","fullWidth":"G57d613"};